import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { GtrakAuthService } from '../../../../../app/features/authentication/services/gtrak-auth.service';
import { WebOrderService } from '../../services/web-order.service';
import { ToasterService } from "../../../../common/services/toaster.service";
import { WebOrderApprovals } from '../../models/web-order-approvals.model';
import { ModalController } from '@ionic/angular';
import {EmailModalComponent } from '../../components/email-modal/email-modal.component';
import { WebOrderCancelModalComponent } from '../../components/web-order-cancel-modal/web-order-cancel-modal.component';
import {CommonService} from '../../../../common/services/common.service'
@Component({
  selector: 'app-wo-approval-page',
  templateUrl: 'wo-approval.page.html',
  styleUrls: [
    './wo-approval.page.scss',
  ]
})
export class WoApprovalPage {
    fromDate: string;
    toDate: string;
    status: string = '0';
    loaded: boolean = false;
    orders: WebOrderApprovals[];
    transferOrders: WebOrderApprovals[] = [];
    loading:boolean=false;
    constructor(
        private router: Router,
        private authService: GtrakAuthService,
        private webOrderService: WebOrderService,
        private toasterService: ToasterService,
        private modalController: ModalController,
        private commonService:CommonService,
        
      ) { 
    }
    ngOnInit(){
      this.loading=false;
      this.setDefaults();
      this.loading=true;
    }
  setDefaults(): void {
    const today = new Date(); 
    const start = new Date();
    start.setDate(today.getDate() - 90); 
    this.fromDate = start.toISOString().substring(0, 10) as any;
    this.toDate = today.toISOString().substring(0, 10) as any;

  }
    async getOrders() {
      //if there is one date set but not the other, throw an error
      this.loading=false;
      if((this.fromDate && !this.toDate) || (!this.fromDate && this.toDate)) {
        this.toasterService.presentToast('danger', '', 'Please select both a start and end date.', 3000);
        this.loading=true;
        return;
      }

      //if both dates are not set then set todate to today and fromdate to 90 days ago
      if(!this.fromDate && !this.toDate) {
        var estdate=new Date(new Date());
        let today =estdate;
        let ninetyDaysAgo =estdate;
        ninetyDaysAgo.setDate(today.getDate() - 90);
        this.fromDate = this.commonService.getDateOnly(ninetyDaysAgo);
        this.toDate = this.commonService.getDateOnly(today);
      }

      this.loaded = false;

      await this.webOrderService.getOrders(this.fromDate, this.toDate, this.status).then((response) => {
        this.orders = response;
      });

      this.loaded = true;
      this.loading=true;

    }

    isOrderWithState2Present(): boolean {
      const present = this.orders.some(order => order.webOrder && order.webOrder.state === 2);
      return present;
    }
  OpenEditModal(order: WebOrderApprovals){
    this.toasterService.presentToast('danger', '', 'Feature not Available.', 3000);
  }
    async OpenViewModal(order: WebOrderApprovals) {
      
       this.router.navigate(['admin-page/wo-approval/view-web-order'],  { state: { order: order } });
     
    }

     async OpenEmailModal(order: WebOrderApprovals) {
      this.loading=false;
      const modal = await this.modalController.create({
        component: EmailModalComponent,
        cssClass: 'min-width-modal-md grey-background',
        showBackdrop: true,
        backdropDismiss: true,
        keyboardClose: true,
        swipeToClose: true,
        componentProps: {
          to: order.webOrder.email,
          subject:"Gallagher Uniform Web Order:"+ order.webOrder.woId
        }
      });
  
      (await modal).present();
      const {data} = await (await modal).onDidDismiss();

      if (data) {
        this.getOrders();
      }
      this.loading=true;
    }

    async OpenCancelModal(order: WebOrderApprovals) {
      this.loading=false;
      const modal = await this.modalController.create({
        component: WebOrderCancelModalComponent,
        cssClass: 'min-width-modal-lg grey-background',
        showBackdrop: true,
        backdropDismiss: true,
        keyboardClose: true,
        swipeToClose: true,
        componentProps: {
          order: order
        }
      });
  
      (await modal).present();
      const {data} = await (await modal).onDidDismiss();

      if (data) {
        this.getOrders();
      }
      this.loading=true;
    }

    AddOrderToTransfer(order: WebOrderApprovals, event: any) {
      
      if(event.target.checked) {
        this.transferOrders.push(order);
      } else {
        this.transferOrders = this.transferOrders.filter(o => o.webOrder.woId !== order.webOrder.woId);
      }
    }

    TransferOrders() {
      this.loading=false;
      //check if transfer orders is empty
      if(this.transferOrders.length === 0) {
        this.toasterService.presentToast('danger', '', 'Please select at least one order to transfer.', 3000);
         this.loading=true;
        return true;
      }

      //check if transfer orders have a selected transfer reason
      for(let order of this.transferOrders) {
        if(order.selectedTransferReason === null || order.selectedTransferReason === "") {
          this.toasterService.presentToast('danger', '', 'Please select a transfer reason for each order.', 3000);
           this.loading=true;
          return true;
        }
      }

      //call the api
      this.webOrderService.transferOrders(this.transferOrders).then((response) => {
        if(response == "Success") {
          this.toasterService.presentToast('primary', '', 'Orders have been transferred.', 3000);
        }
        else {
          this.toasterService.presentToast('danger', `${response}`, 'Orders failed to transfer.', 3000);
        }
        this.getOrders();
        //clear the transfer orders array
        this.transferOrders = [];
      });
       this.loading=true;
    }
}